import { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import Num, { BigNumber } from '@flipster/utils/num';

export interface FeeDiscountState {
  displayFeeRatePercent: BigNumber | null;
  message: ReactNode;
}

export function getMarketDiscountState(estFee: BigNumber, voucher: BigNumber): FeeDiscountState | null {
  if (!voucher.gt(0) || estFee.isZero()) return null;

  if (voucher.gte(estFee)) {
    return { displayFeeRatePercent: Num('0'), message: <FormattedMessage id='Preview.r260128.Feediscount_voucher' /> };
  }

  if (voucher.gt(0)) {
    return {
      displayFeeRatePercent: null,
      message: <FormattedMessage id='Preview.r260128.Feediscount_voucher_partial_after_execution' />,
    };
  }

  return null;
}
